// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a21m9","background-$(backgroundColor)":"b21m9","root":"c21m9","title":"d21m9","spinner":"e21m9","description":"f21m9"};